<template>
  <div class="menu-wrapper">
    <template v-for="menu in menuList">
      <el-submenu v-if="menu.children && menu.children.length >= 1" :index="'' + menu.id">
        <template slot="title">
          <i v-if="menu.icon_cls" :icon-class="menu.icon_cls"></i>
          <span slot="title">{{menu.text}}</span>
        </template>
        <template v-for="secondMenu in menu.children" >
          <el-submenu v-if="secondMenu.children && secondMenu.children.length >= 1" :index="'' + secondMenu.id">
            <template slot="title">
              <i v-if="secondMenu.icon_cls" :icon-class="secondMenu.icon_cls"></i>
              <span slot="title">{{secondMenu.text}}</span>
            </template>
            <template v-for="thridMenu in secondMenu.children">
              <el-menu-item :index="(thridMenu.id)" @click="handleRoute(thridMenu)">
                <i v-if="thridMenu.icon_cls" :icon-class="thridMenu.icon_cls"></i>
                <span slot="title">{{thridMenu.text}}</span>
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :index="(secondMenu.id)" @click="handleRoute(secondMenu)">
            <i v-if="secondMenu.icon_cls" :icon-class="secondMenu.icon_cls"></i>
            <span slot="title">{{secondMenu.text}}</span>
          </el-menu-item>

        </template>
      </el-submenu>
      <el-menu-item v-else :index="(menu.href?menu.href:menu.id)" @click="handleRoute(menu)">
        <i v-if="menu.icon_cls" :icon-class="menu.icon_cls"></i>
        <span slot="title">{{menu.text}}</span>
      </el-menu-item>

    </template>

  </div>
</template>

<script>
import { getMenu } from "@/api/menu";
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      menuList:null
    }
  },
  created(){
    console.log("created");
    getMenu().then(response => {
        console.log("response",response);
        this.menuList = response.data.data.children;
        console.log("menuList",this.menuList);
    });
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    handleRoute (menu) {
      console.log(menu);
      console.log(menu.attributes.url);
      this.$router.push(menu.attributes.url)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue